<div
    (dblclick)="openReservation()"
    (click)="showDetails()"
    class="mf-kab-item d-flex row p-2"
    [ngClass]="{ 'mf-missing-data': missingData, 'mf-priority': data.isPriority }"
>
    <div class="d-flex">
        <div class="mr-4">
            <div *ngIf="showDate" class="mf-date font-weight-bold">
                {{ data?.data?.reservationFrom | date: 'dd.MM.yyyy' }}
            </div>
            <div [class.text-right]="showDate" class="mf-time-start">
                {{ data?.data?.reservationFrom | date: 'HH:mm' }}
            </div>
            <div class="text-right">
                {{ data?.data?.reservationTo | date: 'HH:mm' }}
            </div>
        </div>
        <div>
            <div (click)="$event.stopPropagation(); openCustomer()" ngbTooltip="Odpri stranko" openDelay="300" class="mf-customer-name">
                {{ data?.data?.customer?.name }} {{ data?.data?.customer?.surname }}
            </div>
            <ng-container *ngIf="!data?.data?.title">
                <div>
                    <i class="la la-hand-paper-o"></i>
                    {{ data?.data?.service?.name }}
                </div>
            </ng-container>
            <ng-container *ngIf="data?.data?.title">
                <div>
                    <i class="la la-i-cursor"></i>
                    {{ data?.data?.title }}
                </div>
            </ng-container>
            <div>
                <i class="la la-stethoscope"></i>
                {{ (data?.data?.contractor?.subcontractors)[0]?.name }}
            </div>

            <div *ngIf="isShowDetails" [@expandCollapseHeight]>
                <ng-container [ngTemplateOutlet]="detailsTemplate"></ng-container>
            </div>
        </div>
    </div>

    <div *ngIf="isShowDetails" [@expandCollapseHeight] class="w-100 p-2 pl-4">
        <ng-container *ngIf="isExaminationViewVisible" [ngTemplateOutlet]="examinationsDetailTemplate"></ng-container>
    </div>
</div>

<ng-template #detailsTemplate>
    <section class="pt-1">
        <div>
            <i class="la la-sign-in"></i>
            {{ data?.data?.asset?.name }}
        </div>
        <div>
            <i [tphCallNumber]="data?.data?.customer?.phone" class="la la-phone"></i>
            {{ data?.data?.customer?.phone }}
        </div>
        <div>
            <i class="la la-at"></i>
            {{ data?.data?.customer?.email }}
        </div>
        <div *ngIf="missingData"><small>Stranka ima vnešene nepopolne podatke</small></div>
    </section>
</ng-template>

<ng-template #examinationsDetailTemplate>
    <section class="pt-1">
        <app-examinations-status-list
            [mini]="true"
            [examinationsProgressView]="examinationsProgressView$ | async"
            [examinationsForReservationView]="examinationsForReservationView$ | async"
        ></app-examinations-status-list>
        <app-documentation-status-list *ngIf="isMdpsModuleActive" [statuses]="statusView$ | async"></app-documentation-status-list>
    </section>
</ng-template>
